import type { InvitationResult as InvitationResultModel } from '@/adapters/apiv1.g';
import type { InvitationResult } from '@/types/core/member';
import type { UUID } from '@/utils/uuid';

export function extractInvitationResult(
  model: InvitationResultModel
): InvitationResult {
  return {
    invitationId: model.invitation_id as UUID | undefined,
    tenantId: model.tenant_id as UUID | undefined,
    userId: model.user_id as UUID | undefined,
  };
}
